import { Link } from 'react-router-dom';

export default function GuideSection() {
  return (
    <section className="py-20 md:py-28 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-1/2">
            <div className="rounded-3xl overflow-hidden bg-background-100 p-1">
              <img
                src="https://readdy.ai/api/search-image?query=A%20fashion%20editor%20sitting%20at%20a%20large%20white%20desk%20surrounded%20by%20polaroid%20photos%20of%20outfits%20fabric%20samples%20and%20an%20open%20notebook%20with%20handwritten%20notes%2C%20bright%20airy%20workspace%20with%20plants%2C%20creative%20studio%20lifestyle%20photography%20with%20natural%20light%20and%20inspirational%20atmosphere&width=900&height=700&seq=guide-v2-new-021&orientation=landscape"
                alt="Complete pandabuyspreadsheet shopping guide"
                title="PandabuySpreadsheet complete guide"
                className="w-full h-72 md:h-96 object-cover rounded-2xl object-top"
                loading="lazy"
              />
            </div>
          </div>

          <div className="lg:w-1/2">
            <span className="inline-block px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide uppercase mb-5">
              Deep Dive
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight mb-6 text-balance">
              Curated Fashion <span className="italic text-primary-500">Spreadsheets</span> Made Simple
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Our pandabuyspreadsheet is more than just a list &mdash; it is a complete shopping companion designed to help you discover quality fashion at the best prices. From sneakers to streetwear, every category is meticulously organized so you can find exactly what you need without wasting time on unreliable listings or dead-end searches.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              Whether you are a seasoned spreadsheet shopper or just getting started, our comprehensive guide walks you through everything &mdash; from understanding quality tiers to spotting the best value across different product categories.
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
              <Link
                to="/pandabuy-spreadsheet-guide"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-secondary-500 text-background-50 text-sm font-semibold hover:bg-secondary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-book-open-line"></i>
                <span>Read Full PandabuySpreadsheet Guide</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}